module.exports = __webpack_public_path__ + "img/om-logo.79b799e2.png";